import { render, staticRenderFns } from "./SupportCreate.vue?vue&type=template&id=e4caed6c&scoped=true"
import script from "./SupportCreate.vue?vue&type=script&lang=js"
export * from "./SupportCreate.vue?vue&type=script&lang=js"
import style0 from "./SupportCreate.vue?vue&type=style&index=0&id=e4caed6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4caed6c",
  null
  
)

export default component.exports